import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const KNOWLEDGE_BASE_URL = 'https://info.halda.ai/knowledge';

const KnowledgeBase = () => (
  <div className="my-auto h-6">
    <a
      href={KNOWLEDGE_BASE_URL}
      target="_blank"
      rel="noopener noreferrer"
      id="knowledge-base-icon"
      title="Knowledge base"
      aria-label="Knowledge base"
      className="ml-3 my-auto relative cursor-pointer inline-block"
    >
      <InformationCircleIcon className="h-6 w-6 text-gray-400 hover:text-gray-500" aria-hidden="true" />
    </a>
  </div>
);

export default KnowledgeBase;
